<script>
  import { contentComputed } from '@state/helpers'
  import ContactForm from "@components/forms/contact.vue"
  import appConfig from "@src/app.config.json"
  import youtube from "@components/youtube/youtube-video.vue"

  export default {
    page: {
      title: 'Contacto',
      meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { ContactForm, youtube},

    props: {
      video: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...contentComputed
    }
  }
</script>

<template>
  <div>

    <youtube
      v-if="video"
      :video="info.contact.video"
      style="margin-bottom: 5em"
    />

    <ContactForm/>

    <div class="text-center mt-5">
      <p class="lead">
        <small>{{ info.contact.disclaimer }}</small>
      </p>
    </div>
  </div>
</template>
